const CONTACT_FORM_CONVERSION = {
  sendTo: 'AW-18374445473/efNZCOnB2OMcEKGTz7lE',
  value: 1.0,
  currency: 'TRY',
};

export const reportContactFormConversion = () => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;

  window.gtag('event', 'conversion', {
    send_to: CONTACT_FORM_CONVERSION.sendTo,
    value: CONTACT_FORM_CONVERSION.value,
    currency: CONTACT_FORM_CONVERSION.currency,
  });

  return true;
};

export default {
  reportContactFormConversion,
};
